// extracted by mini-css-extract-plugin
module.exports = {"entrance":"KsgUt","title":"_2A_1F","intro":"_11i58","christmasWrapper":"_1trBa","christmasTheme":"_36C98"};